module.exports = __webpack_public_path__ + "media/images/icon-initials-d7840fe7.svg";